const INITIAL_STATE = {
  active: null,
  changes: 0,
  config: null,
  status: 'ready'
}

const reducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

  case 'ADD':
    return {
      ...state,
      active: action.index,
      changes: state.changes + 1,
      config: {
        ...state.config,
        fields: [
          ...state.config.fields.reduce((fields, field, index) => [
            ...fields,
            ...(index === action.index) ? [action.field] : [],
            field
          ], []),
          ...action.index === state.config.fields.length ? [action.field] : []
        ]
      }
    }

  case 'CLONE':
    return {
      ...state,
      active: null,
      changes: state.changes + 1,
      config: {
        ...state.config,
        fields: [
          ...state.config.fields.reduce((fields, field, index) => [
            ...fields,
            ...(index === action.index) ? [
              field,
              {
                ...field,
                code: action.code
              }
            ] : [field]
          ], [])
        ]
      }
    }

  case 'EDIT':
    return {
      ...state,
      changes: state.changes + 1,
      active: action.field
    }

  case 'MOVE':
    return {
      ...state,
      changes: state.changes + 1,
      config: {
        ...state.config,
        fields: ((action.from < action.to) ? [
          ...state.config.fields.slice(0, action.from),
          ...state.config.fields.slice(action.from + 1, action.to + 1),
          state.config.fields[action.from],
          ...state.config.fields.slice(action.to + 1)
        ] : [
          ...state.config.fields.slice(0, action.to),
          state.config.fields[action.from],
          ...state.config.fields.slice(action.to, action.from),
          ...state.config.fields.slice(action.from + 1)
        ])
      }
    }

  case 'REMOVE':
    return {
      ...state,
      active: null,
      changes: state.changes + 1,
      config: {
        ...state.config,
        fields: [
          ...state.config.fields.filter((field, index) => {
            return index !== action.field
          })
        ]
      }
    }

  case 'SET_CONFIG':
    return {
      ...state,
      changes: 0,
      config: action.config
    }

  case 'SET_STATUS':
    return {
      ...state,
      status: action.status
    }

  case 'UPDATE':
    return {
      ...state,
      changes: state.changes + 1,
      config: action.key ? _.set(_.cloneDeep(state.config), action.key, action.value) : action.value
    }

  default:
    return state
  }

}

export default reducer
